import { apiClient } from './apiClient';
import { TransactionOwner } from './transactionsService';

export type OwnerDraw = {
  id: number;
  month_id: number;
  date: string;
  amount: string;
  owner: TransactionOwner;
  remarks: string | null;
  created_at: string;
  updated_at: string;
  created_by?: { id: number; name: string; email: string };
  updated_by?: { id: number; name: string; email: string };
};

export type OwnerDrawCreatePayload = {
  date: string;
  /**
   * Accounting month in YYYY-MM (11→10 window). Optional; if omitted, backend derives from `date`.
   */
  month?: string;
  amount: number | string;
  owner: TransactionOwner;
  remarks?: string;
};

type ListParams = {
  month?: string;
  owner?: TransactionOwner;
};

type PaginatedResponse<T> = {
  data: T[];
};

export async function listOwnerDraws(token: string, params: ListParams) {
  const query = new URLSearchParams();
  if (params.month) {
    query.set('month', params.month);
  }
  if (params.owner) {
    query.set('owner', params.owner);
  }

  const path = `/owner-draws${query.toString() ? `?${query.toString()}` : ''}`;
  return apiClient<PaginatedResponse<OwnerDraw>>(path, {
    method: 'GET',
    token,
  });
}

export async function createOwnerDraw(token: string, payload: OwnerDrawCreatePayload) {
  return apiClient<{ data: OwnerDraw }>('/owner-draws', {
    method: 'POST',
    token,
    body: JSON.stringify(payload),
  });
}

export async function updateOwnerDraw(token: string, id: number, payload: Partial<OwnerDrawCreatePayload>) {
  return apiClient<{ data: OwnerDraw }>(`/owner-draws/${id}`, {
    method: 'PUT',
    token,
    body: JSON.stringify(payload),
  });
}

export async function deleteOwnerDraw(token: string, id: number) {
  return apiClient<{ message: string }>(`/owner-draws/${id}`, {
    method: 'DELETE',
    token,
  });
}

